<template>
  <div class="form p-2">
    <!-- Different Layout For Different Task -->
    <!-- Advance Request Respond Form -->
    <!-- Add Rate Card Modal -->
    <b-modal centered id="addRateCardModal" class="" title="Add Rate Card" hide-footer>
      <rate-card-form :onSave="handleRateCardSave" :contractDetail="contractDetail"> </rate-card-form>
    </b-modal>
    
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="fullName">Employee</label>
          <multiselect v-model="selectedEmployee" placeholder="Select an employee" label="name" track-by="uuid"
            :options="employees" :option-height="110" :show-labels="false">
            <!-- Selected option label -->
            <template #singleLabel="{ option }">
              <div class="employee-option">
                <img
                  :src="option.profilePic || 'https://gms-file.blr1.cdn.digitaloceanspaces.com/No-Image-Placeholder.png'"
                  class="employee-img" alt="Profile" />
                <span class="employee-name">{{ option.name }}</span>
              </div>
            </template>

            <!-- Dropdown option template -->
            <template #option="{ option }">
              <div class="employee-option">
                <img
                  :src="option.profilePic || 'https://gms-file.blr1.cdn.digitaloceanspaces.com/No-Image-Placeholder.png'"
                  class="employee-img" alt="Profile" />
                <div class="employee-info">
                  <div class="employee-name">{{ option.name }}</div>
                  <div class="employee-designation">{{ option.designation }}</div>
                </div>
              </div>
            </template>
          </multiselect>
          <b-form-invalid-feedback :class="{ 'd-block mb-2': isSubmit && errorMsg.employeeId }">
            {{ isSubmit && errorMsg.employeeId ? errorMsg.employeeId : '' }}
          </b-form-invalid-feedback>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <label class="dob-input">Salary*</label>
        <b-input-group class="custom-input-group">
          <multiselect 
            v-model="selectedRateCard" 
            :options="filteredRateCards" 
            track-by="id" 
            label="rate" 
            :custom-label="rateWithType" 
            :show-labels="false"
            :taggable="true"
            :tag-placeholder="'Enter rate amount (e.g., 15000) and press Enter'"
            @tag="createCustomRateCard"
            placeholder="Select rate or type amount"
          ></multiselect>
          <b-input-group-append>
            <b-button variant="primary" v-b-modal.addRateCardModal>+</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :class="{ 'd-block mb-2': isSubmit && errorMsg.rateCardId }">
          {{ isSubmit && errorMsg.rateCardId ? errorMsg.rateCardId : '' }}
        </b-form-invalid-feedback>
      </div>
    </div>
    
    <div class="row">
    </div>
    <div class="row">

    </div>

    <div class="row">
      <div class="col text-center">
        <b-button variant="primary" @click="saveReplace">Save</b-button>
      </div>
    </div>
  </div>
</template>
<style scoped>
.custom-input-group {
  display: flex;
}

.custom-input-group .multiselect {
  flex: 1;
  /* Allows the multiselect to grow and fill the available space */
}

.custom-input-group .input-group-append {
  flex-shrink: 0;
  /* Prevents the button from shrinking */
}

.employee-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.employee-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.employee-info {
  display: flex;
  flex-direction: column;
}

.employee-name {
  font-weight: 600;
  font-size: 16px;
}

.employee-designation {
  font-size: 14px;
  color: #777;
}

/* Custom styling for taggable multiselect */
.multiselect__tag {
  background: #007bff !important;
  color: white !important;
}

.multiselect__tag-icon:after {
  color: white !important;
}

.multiselect__tag-icon:hover {
  background: #0056b3 !important;
}

.multiselect__input {
  border: none !important;
  outline: none !important;
}

.multiselect__placeholder {
  color: #6c757d !important;
  font-size: 14px !important;
}
</style>
<script>
//flatpickr
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import '@/assets/sass/forms/custom-flatpickr.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

//RateCard
import RateCardForm from '@/components/module/RateCardForm.vue';

export default {
  props: {
    initialAssignment: {
      type: Object,
      required: true,
    },
    initialOtherAttendance: {
      type: Object,
    },
    onSave: {
      type: Function,
      required: true,
    },
  },
  components: {
    Multiselect,
    RateCardForm,
  },
  data() {
    return {
      selectedEmployee: null,
      selectedRateCard: null,
      assignment: this.initialAssignment
        ? { ...this.initialAssignment }
        : {},
      errorMsg: {},
      isSubmit: false,
      sa: null,
      employees: [],
      contractDetail: null,
    };
  },
  watch: {},
  computed: {
    // employees() {
    //   const employees = this.$store.state.employees.employees;
    //   if (this.initialAssignment && this.initialAssignment.employeeId) {
    //     return employees.filter(emp => emp.uuid !== this.initialAssignment.employeeId);
    //   }
    //   return []
    // },
    rateCards() {
      return this.$store.state.business.rate_cards;
    },
    filteredRateCards() {
      if (this.contractDetail && this.contractDetail.manpowerTypeId && this.rateCards) {
        return this.rateCards.filter((rateCard) => rateCard.manpowerTypeId === this.contractDetail.manpowerTypeId);
      } else {
        return this.rateCards
      }
    },
  },
  async mounted() {
    this.sa = this.$swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
    await this.$store.dispatch('business/getRateCards');
    await this.fetchEmployees();
    //get contract detail
    const contractDetail = await this.$store.dispatch('business/getContractDetail', this.assignment.contractDetailId);
    this.contractDetail = contractDetail;
  },
  methods: {
    rateWithType({ rate, ManpowerType, durationType }) {
      return `${ManpowerType.name} — [${rate}/${durationType}]`;
    },
    handleRateCardSave(rate_card) {
      let rateCard = this.rateCards.find((item) => item.id === rate_card.id);
      if (rateCard) {
        this.selectedRateCard = rateCard;
        this.$bvModal.hide('addRateCardModal');
      }
    },
    async createCustomRateCard(rateAmount) {
      try {
        // Clean the input - remove currency symbols, commas, spaces
        const cleanedAmount = rateAmount.toString().replace(/[₹,\s]/g, '');
        
        // Validate input is a valid number
        const rate = parseFloat(cleanedAmount);
        if (isNaN(rate) || rate <= 0) {
          this.sa.fire({
            icon: 'error',
            title: 'Please enter a valid rate amount (numbers only)'
          });
          return;
        }

        // Check if contract detail exists
        if (!this.contractDetail || !this.contractDetail.manpowerTypeId) {
          this.sa.fire({
            icon: 'error',
            title: 'Contract details not available. Please try again.'
          });
          return;
        }

        // Check if a rate card with this amount already exists for this manpower type
        const existingRateCard = this.filteredRateCards.find(rc => 
          parseFloat(rc.rate) === rate && rc.durationType === 'monthly'
        );
        
        if (existingRateCard) {
          // Auto-select the existing rate card instead of creating duplicate
          this.selectedRateCard = existingRateCard;
          this.sa.fire({
            icon: 'info',
            title: `Rate card already exists! Selected existing ₹${rate}/monthly rate card.`
          });
          return;
        }

        // Create new rate card object
        const newRateCard = {
          rate: rate,
          manpowerTypeId: this.contractDetail.manpowerTypeId,
          durationType: 'monthly',
          effective_date: this.$moment().format('YYYY-MM-DD'),
          // Add any other fields that might be required
          contractDetailId: this.contractDetail.id || null,
          createdBy: this.$store.state.auth?.user?.uuid || null,
          isActive: true,
          description: `Auto-created rate card - ₹${rate}/monthly`
        };

        // Show loading indicator
        this.sa.fire({
          icon: 'info',
          title: 'Creating rate card...',
          timer: 1000
        });

        // Save to store/API - using the same action as the rate card form
        const savedRateCard = await this.$store.dispatch('business/addRateCard', newRateCard);
        
        if (savedRateCard && savedRateCard.id) {
          // Refresh rate cards to get the updated list
          await this.$store.dispatch('business/getRateCards');
          const rate_card = this.rateCards.find(rc => rc.id === savedRateCard.id);
          // Auto-select the newly created rate card
          this.selectedRateCard = rate_card;
          
          this.sa.fire({
            icon: 'success',
            title: `Rate card created successfully! (₹${rate}/monthly)`
          });
        } else {
          throw new Error('Failed to create rate card');
        }
      } catch (error) {
        console.error('Error creating custom rate card:', error);
        this.sa.fire({
          icon: 'error',
          title: 'Failed to create rate card. Please try again or use the + button.'
        });
      }
    },
    formatCurrency(price) {
      //format price to number
      const amount = parseFloat(price);
      //return '' if not price
      if (isNaN(amount)) return '';
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0, // No digits after the decimal point
        maximumFractionDigits: 0, // No digits after the decimal point, ensures rounding
      }).format(amount);
    },

    async fetchEmployees() {
      console.log('fetching emp')
      const employees = await this.$store.dispatch('employees/getAllStaffs');

      if (this.initialAssignment && this.initialAssignment.employeeId) {
        this.employees = employees.filter(emp => emp.uuid !== this.initialAssignment.employeeId);
      }
    },

    formatDate(date) {
      return this.$moment(date).format('MMM Do, YYYY');
    },
    handleEmployeeChange(emp) {
      this.selectedEmployee = emp
    },
    validateFields() {
      let flag = false;

      //Check Condition And Set Flag true if not matched
      if (!this.selectedEmployee || !this.selectedEmployee.uuid) {
        flag = true;
        this.$set(this.errorMsg, 'employeeId', 'Employee Is Required')
      }
      if (!this.selectedRateCard || !this.selectedRateCard.id) {
        flag = true;
        this.$set(this.errorMsg, 'rateCardId', 'Rate is Required!')
      }
      if (!flag) {
        return true;
      } else {
        return false;
      }
    },
    resetFields() {
      this.errorMsg = {};
      this.isSubmit = false;
    },
    async saveReplace() {
      this.errorMsg = {};
      this.isSubmit = true;
      
      if (!this.validateFields()) {
        this.sa.fire({
          icon: 'error',
          title: `Check For Errors!`,
        });
        return;
      }

      if (this.initialOtherAttendance && this.initialOtherAttendance.id && this.initialOtherAttendance.status === 'present') {
        this.sa.fire({
          icon: 'error',
          title: `Please Mark the attendance to absent before replacing the employee!`
        });
        this.onSave(false)
        return;
      } else {
        const assignmentId = this.assignment.assignmentId;
        const currentEmployeeId = this.assignment.employeeId;
        const targetEmployeeId = this.selectedEmployee.uuid;

        try {
          // Fetch current assignment and employee assignments
          const assignment = await this.$store.dispatch('employees/getEmployeeAssignment', assignmentId);
          const currentEmpAssignments = await this.$store.dispatch('employees/getEmployeeAssignmentsByEmpId', currentEmployeeId);
          const targetEmpAssignments = await this.$store.dispatch('employees/getEmployeeAssignmentsByEmpId', targetEmployeeId);

          console.log('Current Assignment:', assignment);
          console.log('Current Employee Assignments:', currentEmpAssignments);
          console.log('Target Employee Assignments:', targetEmpAssignments);

          // Step 1: Delete all current employee assignments
          for (const empAssignment of currentEmpAssignments) {
            await this.$store.dispatch('employees/deleteAssignment', empAssignment.id);
          }

          // Step 2: Delete all target employee assignments
          for (const empAssignment of targetEmpAssignments) {
            await this.$store.dispatch('employees/deleteAssignment', empAssignment.id);
          }

          // Step 3: Create new assignments based on currentEmpAssignments
          const today = new Date().toISOString().slice(0, 10);
          const newAssignments = currentEmpAssignments.map((empAssignment) => ({
            ...empAssignment,
            id: undefined, // clear existing id to allow creation
            employeeId: targetEmployeeId,
            start_date: today,
            rateCardId: this.selectedRateCard.id
          }));

          console.log('Final Assignments: ', newAssignments)
          await this.$store.dispatch('employees/addEmployeeAssignments', newAssignments);
          this.onSave(true);
          console.log('Employee assignments replaced successfully.');
        } catch (error) {
          console.error('Error during replacement:', error);
        }
      }

      // this.errorMsg = {};
      // this.isSubmit = true;
      // if (this.validateFields()) {
      //   if (this.initialTransaction && this.initialTransaction.id) {
      //     this.transaction.payment_date = this.$moment().format('YYYY-MM-DD')
      //     this.transaction.paid_by = this.$store.state.employees.employee.uuid
      //     //Update Transaction
      //     const transaction = this.$store.dispatch('employees/updateTransaction', this.transaction)
      //     if (transaction) {
      //       this.sa.fire({
      //         icon: 'success',
      //         title: `Transaction Successfully Updated!`
      //       });
      //       console.log('Transaction Form On Save...')
      //       this.onSave(transaction);
      //     }
      //   } else {
      //     //Save Transaction Pending code
      //     if (!this.transaction.id) {
      //       if (!this.isValidAmount) {
      //         const result = await this.$swal.fire({
      //           title: 'Are You Sure?',
      //           text: 'Advance Amount is either less than 100 or more than the maximum Advance Amount Allowed',
      //           icon: 'warning',
      //           showCancelButton: true,
      //           confirmButtonText: 'Yes, I Understand',
      //           cancelButtonText: 'Ohh Sorry!'
      //         });

      //         if (result.isConfirmed) {
      //           await this.$store.dispatch('business/addTransaction', this.transaction)
      //           const addedTransaction = await this.$store.state.business.addedTransaction
      //           if (addedTransaction.id) {
      //             this.sa.fire({
      //               icon: 'success',
      //               title: `Advance Processed Successfully!`
      //             });
      //             this.onSave(addedTransaction);
      //           }
      //         } else {
      //           return;
      //         }
      //       } else {
      //         const addedTransaction = await this.$store.dispatch('business/addTransaction', this.transaction)
      //         if (addedTransaction && addedTransaction.id) {
      //           this.sa.fire({
      //             icon: 'success',
      //             title: `Advance Processed Successfully!`
      //           });
      //           this.onSave(addedTransaction);
      //         }
      //       }
      //     } else {
      //       this.sa.fire({
      //         icon: 'error',
      //         title: `Check For Errors!`
      //       });
      //     }

      //   }
      //   // Use the provided onSave handler
      // } else {
      //   this.sa.fire({
      //     icon: 'error',
      //     title: `Check For Errors!`,
      //   });
      // }
    },
      },
  };
</script>